// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Hide input type number spinners */
input[type="number"] {
    -moz-appearance: textfield;
    appearance: textfield;
}

/* Webkit browsers like Safari and Chrome */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.LogMonumental__showMoreLink___bwGtY {
    text-align: center;
}

.LogMonumental__logMonumentalTable___b7Gs4 {
    margin-bottom: 0;
    margin: 10px 25px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}

.LogMonumental__row___YwNyG {
    text-align: center;
    display: flex;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"showMoreLink": `LogMonumental__showMoreLink___bwGtY`,
	"logMonumentalTable": `LogMonumental__logMonumentalTable___b7Gs4`,
	"row": `LogMonumental__row___YwNyG`
};
module.exports = ___CSS_LOADER_EXPORT___;
